import { api } from './api';
export const authApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // 登录
        login: builder.mutation({
            query: (credentials) => ({
                url: '/auth/login',
                method: 'POST',
                body: credentials,
            }),
            invalidatesTags: ['User'],
        }),
        // 注册
        register: builder.mutation({
            query: (userData) => ({
                url: '/auth/register',
                method: 'POST',
                body: userData,
            }),
            invalidatesTags: ['User'],
        }),
        // 登出
        logout: builder.mutation({
            query: () => ({
                url: '/auth/logout',
                method: 'POST',
            }),
            invalidatesTags: ['User'],
        }),
        // 获取当前用户信息
        getCurrentUser: builder.query({
            query: () => '/auth/me',
            providesTags: ['User'],
        }),
        // 刷新 token
        refreshToken: builder.mutation({
            query: (body) => ({
                url: '/auth/refresh',
                method: 'POST',
                body,
            }),
        }),
    }),
});
export const { useLoginMutation, useRegisterMutation, useLogoutMutation, useGetCurrentUserQuery, useRefreshTokenMutation, } = authApi;
